import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Country from "./Country";
export class ProductOverview {
  constructor() {
    _defineProperty(this, "ProductCountry", {
      fieldName: 'product_country',
      model: Country,
      content: null
    });
    _defineProperty(this, "ProductAvailableQuantity", {
      fieldName: 'product_available_quantity',
      content: null
    });
    _defineProperty(this, "ProductDailySales", {
      fieldName: 'product_daily_sales',
      content: null
    });
    _defineProperty(this, "ProductWeeklySales", {
      fieldName: 'product_weekly_sales',
      content: null
    });
    _defineProperty(this, "ProductOutOfStock", {
      fieldName: 'product_out_of_stock_in',
      content: null
    });
  }
}
export default ProductOverview;